module.exports = __webpack_public_path__ + "img/home1_yinliu_logo.d643f0ed.png";